/* src/app/modules/shared/components/column/column-craft-designation/column-craft-designation.component.scss */
app-column-craft-designation {
  display: contents;
}
/*# sourceMappingURL=column-craft-designation.component.css.map */
